import gql from "graphql-tag";

export default {
update: gql`
    mutation UpdatePhotoboothGifCell2 ($input: UpdatePhotoboothGifCell2Input!) {
        updatePhotoboothGifCell2 (input: $input) {
            id
            send_email
            gif_uri
            background_color
            text_color
            button_download_background_color
            button_download_text_color
            button_retake_background_color
            button_retake_border_color
            button_retake_text_color
            button_print_background_color
            qr_card_background_color
            qr_code_color
            button_download_text
            button_retake_text
            button_take_text
            send_text
            sent_text
            look_text
            description_text
            conditions1_text
            conditions2_text
            send_by_email_text
            print_text
            printed_text
            preparing_photo_text
            almost_there_text
            print_title_text
            email
            qr_code
            print
            cameralabel
            remove_background
            mirror_image
            background_image_uri
            photo_format
            square_gif_uri
            photo_timer
            photo_timer_direction
            panini_print
            loader_background_color
            loader_spinner_color
            camera_rotation
            collect_user_info
            user_info_bar_color
            user_info_text_color
            user_info_text_size
            user_info_text_position
            user_info_text_h_position
            text_font
            text_size
            letter_spacing
            fullscreen_reveal
            fullscreen_camera
            fullscreen_reveal_duration
            qr_code_size
            qr_title_size
            print_title_size
            share_column_gap
            share_preview_width
            share_controls_offset
            share_preview_offset
            print_photo_offset
            share_link_page_id
            change_bg_page_id
            change_bg_button_position
            change_bg_text
            share_link_background_color
            share_link_text_color
            share_link_border_color
            share_link_text
            button_take_text_color
            look_text_color
            arrows_color
            button_retake_text_size
            button_retake_text_bold
            print_text_size
            print_text_bold
            qr_title_bold
            print_title_bold
            camera_resolution
            email_subject
            email_body
            email_from
            i18n{
                button_download_text
                button_retake_text
                button_take_text
                send_text
                sent_text
                look_text
                description_text
                conditions1_text
                conditions2_text
                send_by_email_text
                print_text
                printed_text
                preparing_photo_text
                almost_there_text
                print_title_text
                share_link_text
                email_subject
                email_body
            }
        }
    }`,

get: gql`
    query PhotoboothGifCell2($id: ID!) {
        photoboothGifCell2(id: $id) {
            id
            send_email
            gif_uri
            background_color
            text_color
            button_download_background_color
            button_download_text_color
            button_retake_background_color
            button_retake_border_color
            button_retake_text_color
            button_print_background_color
            qr_card_background_color
            qr_code_color
            button_download_text
            description_text
            conditions1_text
            conditions2_text
            send_by_email_text
            print_text
            printed_text
            preparing_photo_text
            almost_there_text
            print_title_text
            email
            qr_code
            print
            cameralabel
            remove_background
            mirror_image
            background_image_uri
            photo_format
            square_gif_uri
            photo_timer
            photo_timer_direction
            panini_print
            loader_background_color
            loader_spinner_color
            camera_rotation
            collect_user_info
            user_info_bar_color
            user_info_text_color
            user_info_text_size
            user_info_text_position
            user_info_text_h_position
            text_font
            text_size
            letter_spacing
            fullscreen_reveal
            fullscreen_camera
            fullscreen_reveal_duration
            qr_code_size
            qr_title_size
            print_title_size
            share_column_gap
            share_preview_width
            share_controls_offset
            share_preview_offset
            print_photo_offset
            share_link_page_id
            change_bg_page_id
            change_bg_button_position
            change_bg_text
            share_link_background_color
            share_link_text_color
            share_link_border_color
            share_link_text
            button_take_text_color
            look_text_color
            arrows_color
            button_retake_text_size
            button_retake_text_bold
            print_text_size
            print_text_bold
            qr_title_bold
            print_title_bold
            camera_resolution
            email_subject
            email_body
            email_from
            i18n{
                button_download_text
                button_retake_text
                button_take_text
                send_text
                sent_text
                look_text
                description_text
                conditions1_text
                conditions2_text
                send_by_email_text
                print_text
                printed_text
                preparing_photo_text
                almost_there_text
                print_title_text
                share_link_text
                email_subject
                email_body
            }
        }
    }`
}
